// src/components/pages/EventManager/organisms/HeaderWithButton.js

import React from "react";
import { Box, Typography } from "@mui/material";
import PropTypes from "prop-types";
import CustomButton from "../atoms/CustomButton";

const HeaderWithButton = ({ title, buttonText, onButtonClick, theme }) => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      mb: 2,
    }}
  >
    <Typography variant="h6" sx={{ fontFamily: "basic-sans" }}>
      {title}
    </Typography>
    <CustomButton onClick={onButtonClick} theme={theme}>
      {buttonText}
    </CustomButton>
  </Box>
);

HeaderWithButton.propTypes = {
  title: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  onButtonClick: PropTypes.func.isRequired,
  theme: PropTypes.object.isRequired,
};

export default HeaderWithButton;